import PropTypes from 'prop-types';
import Header from './Header';
import Footer from '../Footer/BaseFooter';

const TestSeriesFlexLayout = ({
  children,
  className,
  showFooter,
  showLogin,
  layoutOptions = {}
}) => {
  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Header
        showLogin={layoutOptions.showLogin ?? showLogin}
        className={className}
      />
      {children}
      <Footer display={layoutOptions.showFooter ?? showFooter} />
    </div>
  );
};

TestSeriesFlexLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  showLogin: PropTypes.bool
};

TestSeriesFlexLayout.defaultProps = {
  className: '',
  showFooter: true,
  showLogin: false
};

export default TestSeriesFlexLayout;
